module.exports = __webpack_public_path__ + "static/003.thumb-9702a6044a0e367b94f6b3216109b4a4.jpg";